import {PALETTE_IDS} from '#core/application/modules/ids.js';

import {COLOR, FONT} from '../theme.js';

export function getSportsContentConfigs() {
    return {
        palette: {
            [PALETTE_IDS.EVENT_PAGE]: {
                EVENT_PAGE_VISUALISATION_SELECTOR: {
                    TOGGLE_BUTTON_SELECTED_BG: COLOR.BRAND.ACCENT3,
                    TOGGLE_BUTTON_TEXT: {
                        fontWeight: FONT.WEIGHT_MEDIUM,
                    },
                },
                MARKETS_GROUPS_SELECTOR_BUTTON: {
                    TOGGLE_BUTTON_SELECTED_BG: COLOR.BRAND.ACCENT3,
                },
            },
            [PALETTE_IDS.EVENT_LIST]: {
                EVENT_LIST_GROUP_HEADER_BG: COLOR.BRAND.BACKGROUND3,
                EVENT_LIST_GROUP_NAME_TEXT: {
                    color: COLOR.BRAND.FOREGROUND1,
                    fontWeight: FONT.WEIGHT_SEMI_BOLD,
                },
                EVENT_LIST_GROUP_MARKET_TEXT: {
                    color: COLOR.BRAND.FOREGROUND1,
                    fontWeight: FONT.WEIGHT_NORMAL,
                },
            },
            [PALETTE_IDS.SPORT_PAGE]: {
                SPORT_HEADER_BG: COLOR.BRAND.BACKGROUND7,
                SPORT_HEADER_TEXT: {
                    color: COLOR.BRAND.FOREGROUND1,
                    textTransform: 'uppercase',
                },

                LEAGUES_SECTION_HEADER_TEXT: {
                    color: COLOR.BRAND.FOREGROUND2,
                    fontFamily: FONT.FAMILY_SECOND,
                    fontWeight: FONT.WEIGHT_SEMI_BOLD,
                    fontSize: FONT.SIZE_LARGE,
                    textTransform: 'uppercase',
                },
                LEAGUES_HEADER_TEXT: {
                    color: COLOR.BRAND.FOREGROUND1,
                    fontWeight: FONT.WEIGHT_SEMI_BOLD,
                },
                LEAGUES_ITEM_NAME_TEXT: COLOR.BRAND.FOREGROUND1,

                EVENT_LIST_SKELETON: {
                    EVENT_LIST_HEADER_BG: COLOR.BRAND.BACKGROUND1,
                    EVENT_LIST_GROUP_HEADER_BG: COLOR.BRAND.BACKGROUND1,
                },
            },
            [PALETTE_IDS.COUPONS]: {
                COUPONS_TITLE_TEXT: {
                    color: COLOR.BRAND.FOREGROUND1,
                    fontSize: FONT.SIZE_LARGE,
                    fontWeight: FONT.WEIGHT_BOLD,
                },
                TOP_SPORTS_SPORT_SELECTOR: {
                    TOGGLE_BUTTON_SELECTED_BG: COLOR.BRAND.ACCENT3,
                },
            },
            [PALETTE_IDS.HOME_PAGE]: {
                HOME_PAGE_TOP_SPORTS_CONTAINER_BG: COLOR.BRAND.BACKGROUND6,
                HOME_PAGE_TOP_SPORTS_SKELETON_PART: {
                    SKELETON_COLOR: COLOR.BRAND.BACKGROUND7,
                },
            },
            [PALETTE_IDS.INPLAY_PAGE]: {
                INPLAY_SPORTS_SELECTOR: {
                    TOGGLE_BUTTON_SELECTED_BG: COLOR.BRAND.ACCENT3,
                },
            },
        },
    };
}
